import styled from "styled-components";
import { Search } from "../../../Assets/icons";
import SVG from "react-inlinesvg";

export const SwiperStyles = {
    display: 'flex', 
    flexDirection:'row',
    height: '440px', 
    padding: '5px 0',
    paddingInline: '15px',
    width: '400px', 
    
    "--swiper-pagination-color": "#006560", 
    "--swiper-navigation-color": "#006560", 
    "swiperButtonPrev": "#006560", 
    "swiperButtonNext": "#006560"
}

export const SwiperMobileStyles = {
    display: 'flex',
    alignItems:'center', 
    flexDirection:'row',
    height: '200px', 
    paddingInline: '20px',
    width: '100%', 
    "--swiper-pagination-color": "#006560", 
    "--swiper-navigation-color": "#006560",
    "swiperButtonPrev": "#006560", 
    "swiperButtonNext": "#006560"
}

export const Container = styled.main`
    background: #FFF;
    display: flex;
    flex-direction: column;
    gap: 10px;
    overflow: ${({$isTourOpen}) => ($isTourOpen ? 'hidden !important' : 'auto')};
    padding: 75px 0 100px;
    width: 100%;
    @media (min-width: 720px) {
        padding: 20px 120px 0 200px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        padding: 5px 20px 100px;
    }
`;

export const Header = styled.div`
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin: 0 10px;

    @media (min-width: 720px) {
        align-items: flex-end;
        margin: 0;
    }
`;

export const ContainerSelect = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 12px;
    justify-content: center;
    width: 100%;

    @media (min-width: 720px) {
        flex-direction: row;
        justify-content: space-between;
    }

    div.selects{
        display: flex;
        flex-direction: column;
        gap: 10px;

        @media (min-width: 720px) {
            flex-direction: row;
            gap: 20px;
        }
    }

    .report-buttons-container {
        display: flex;
        gap: 18px;
    }
`;

export const UpdateIcon = styled(SVG)`   
    height: 20px;
    width: 20px;
    & path {
        fill: ${({ color }) => color};
    }
`;

export const ContainerTop = styled.div`
    display: flex;
    flex: 0.8;
    gap: 10px;
    justify-content: space-around;
    flex-direction: row-reverse;
    @media (min-width: 720px) {
        gap: 30px;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
    @media (min-width: 1500px){
        flex-direction: row;
        justify-content: space-around;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        flex-direction: column;
        gap: 10px;
    }
`;


export const ContainerDonut = styled.div`
    width: 678px;
    height: 480px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 10px;
    padding: 20px;
    background: #FFF;
    box-shadow: -1px 1px 11px 0 rgba(0, 0, 0, 0.25) inset, 2px 2px 4px 0 rgba(0, 0, 0, 0.25);
    @media (min-width: 720px) {
        padding: 48px 78px;
    }
`;

export const ContainerCardsSlim = styled.div`
    align-items: center;
    justify-content: center;
    display: none;
    flex-wrap: wrap;
    gap: 20px;
    height: 0px;
    max-width: 594.546px;
    position: relative;
    visibility: hidden;
    width: fit-content;
    @media (min-width: 720px) {
        display: flex;
        height: auto;
        visibility: visible;
        width:auto;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        display: none;
        height: 0px;
        visibility: hidden;
        width: 0px;
    }

    .swiper-pagination-bullet {
        background: #FFFFFF;
        border: 1px solid #006560;
        padding: 5px;
        opacity: 1;
    }
    .swiper-pagination-bullet-active {
        background-color: #006560
    }
`;

export const SearchInput = styled.input`
    background: url(${Search}) left 5px center / 22px no-repeat;
    border: 1px solid #006560;
    border-radius: 5px;
    color: #333;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    margin-left: 32px;
    outline: #006560;
    padding: 10px 10px 10px 32px;
    width: 246px;

    &:hover{
        background-color: #F2F2F2;
        border-color: #33CC99;
    }
    &::placeholder {
        color: #333;
        opacity: 1;
    }
    &:disabled{
        cursor: not-allowed;
    }
    @media (min-width: 720px) {
        font-size: 16px;
        width: 316px;
    }
`;

export const ContainerCardsSlimMobile = styled.div`
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: center;
    margin: auto;
    max-width: 594.546px;
    position: relative;
    width: 100%;
    padding-top: 20px;
    @media (min-width: 720px) {
        display: none;
        height: 0px;
        visibility: hidden;
        width: 0px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        display: flex;
        height: auto;
        max-width: 100%;
        visibility: visible;
        width: auto;
    }
`;

export const ContainerBottom = styled.div`
    align-items: center;
    border : 2px solid #08928B;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 1%;
    margin-bottom: 15px;
    padding: 10px 25px 0px 25px;
    position: relative;
    width: 98%;
    @media (min-width: 720px) {
        margin: 0;
        margin-bottom: 15px;
        width: 100%;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        display: none;
    }
`;

export const ContainerBottomMobile = styled.div`
    align-items: center;
    border: 2px solid #08928B;
    border-radius: 5px;
    display: none;
    flex-direction: column;
    justify-content: center;
    margin: 1%;
    margin-bottom: 15px;
    padding: 10px 25px 0px 25px;
    width: 55%;
    @media(orientation: landscape) and (max-width: 1080px){
        display: flex;
        width: 100%;
    }
`;


export const StateText = styled.h2`
    display: flex;
    gap: 20px;
    justify-content: center;
    margin-block: 5px;
    padding: 12px;
    background: #F6F6F6;
    border-radius: 5px;
    box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.25);
    width: 100%;
    height: 52px;
    color: #333;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    @media (min-width: 720px) {
        margin-block: 10px;
        font-size: 24px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        margin-block: 5px;
        padding: 10px;
        font-size: 16px;
    }
`;

export const StateContainer = styled.div`
    align-items: center;
    display: flex;
    gap: 15px;
    justify-content: space-between;
    width: 100%;
`;

export const StateMonthText = styled.h3`
    background: #FFF;
    border-radius: 5px;
    box-shadow: 0px 1.52px 1.52px 0px rgba(0, 0, 0, 0.25);
    color: #333;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    padding: 8px;
    text-align: flex-start;
    @media (min-width: 720px) {
        font-size: 24px;
        padding: 15px 20px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        font-size: 15px;
        padding: 8px;
    }
`;



export const ButtonCalendar = styled.div`
    padding:10px;
    margin-left: auto;
`;


export const CardsLoader = styled.div`
    display: flex;
    flex-wrap: wrap;   
    gap: 20px;
    max-width: 594.546px;
    width: 100%;
    width: fit-content;
`;

export const LastUpdateContainer = styled.div`
    align-items: center;
    display: flex;
    gap: 10px;
    justify-content: flex-end;

    @media (min-width: 720px) {
        flex-direction: row;
        gap: 20px;
    }

    div.date-time {
        align-items: flex-end;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
`;
 
export const LastUpdateIcon = styled.img`
    height: 16px;
    width: 16px;
`;

export const LastUpdateText = styled.span`
    /* align-self: end; */
    color: #333;
    display: flex;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    gap: 10px;
    line-height: normal;
    text-align: center;
    @media (min-width: 720px) {
        padding-right: 0px;
    }
`;



export const ImageIcon = styled(SVG)`
    height: 24px;
    width: 24px;
    & path {
        fill: currentColor;
    }
`;


export const HeaderContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    padding: 10px 20px;
    gap: 10px;

    @media (min-width: 720px) {
        display: flex;
        flex-direction: row;
        justify-content: ${({ $top }) => $top ? 'space-between' : 'space-around'};
        padding: 10px 0;
        width: 100%;
    }

    @media (min-width: 768px) and (max-width: 1024px) {
        align-items: center;
        flex-direction: column;
        justify-content: center;
    }

    .selects {
        display: flex;
        flex-direction: column;
        gap: 20px;

        @media (min-width: 720px) {
            flex-direction: row;
        }
    }

    .buttons-container {
        align-items: center;
        display: flex;
        gap: 10px;
        justify-content: space-around;
        
        @media (min-width: 720px) {
            flex-direction: row;
            width: 50%;
        }
    }
`;
